export type DisplayStatus = 'paid' | 'unpaid' | 'recalled' | 'pending' | 'allocated'

type StatusInput = {
  type?: string | null
  display_type?: string | null
  status?: string | null
}

export function getDisplayStatus(item: StatusInput): DisplayStatus {
  if (item.display_type === 'scheduled_call') return 'pending'

  if (item.type === 'capital_call') {
    return item.status === 'paid' ? 'paid' : 'unpaid'
  }

  if (item.type === 'distribution') {
    if (item.status === 'paid') return 'paid'
    if (item.status === 'recalled') return 'recalled'
    return 'unpaid'
  }

  if (item.type === 'portfolio_distribution') return 'pending'

  return 'allocated'
}

export const STATUS_FILTER_OPTIONS: { value: DisplayStatus; text: string }[] = [
  { value: 'paid', text: 'Paid' },
  { value: 'unpaid', text: 'Unpaid' },
  { value: 'recalled', text: 'Recalled' },
  { value: 'pending', text: 'Pending' },
  { value: 'allocated', text: 'Allocated' },
]
